module.exports = __webpack_public_path__ + "img/Cancel.47a82c78.svg";